module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_house-d9dc839c5559e29880fc4e8ee4ea7628.png";